import React, { Component } from 'react';

class MemeGenerator extends Component {
	constructor() {
		super()
		this.state = {
			topText: '',
			bottomText: '',
			randomImg: 'http://i.imgflip.com/1bij.jpg',
			allMemeImgs: []
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		fetch('https://api.imgflip.com/get_memes')
			.then(response => response.json())
			.then(response => {
				const {memes} = response.data;
				this.setState({ allMemeImgs: memes })
			})
	}

	handleSubmit(event) {
		event.preventDefault()
		const randomIndex = Math.floor(Math.random() * this.state.allMemeImgs.length);
		const displayImg = this.state.allMemeImgs[randomIndex].url;
		this.setState({ randomImg: displayImg });
	}

	handleChange(event) {
		const {name, value} = event.target;
		this.setState({ [name]: event.target.value })
	}

	render() {
		return (
			<div>
				<form className='meme-form' onSubmit={this.handleSubmit}>
					<input 
						type='text'
						name='topText'
						placeholder='Top Text'
						value={this.state.topText}
						onChange={this.handleChange}
					/>
					<input 
						type='text'
						name='bottomText'
						placeholder='Bottom Text'
						value={this.state.bottomText}
						onChange={this.handleChange}
					/>
					<button>Gen</button>
				</form>
				<div className='meme'>
					<img 
						src={this.state.randomImg} 
						alt='Randomly selected image'
					/>
					<h2 className='top'>{this.state.topText}</h2>
					<h2 className='bottom'>{this.state.bottomText}</h2>
				</div>
			</div>
		)
	}
}

export default MemeGenerator;